import { createReducer } from '@reduxjs/toolkit';
import { RequestError } from 'types';
import {
  updateMessageMask,
  updatedMessageMask,
  fetchMessageMask,
  fetchedMessageMask,
  fetchedMessagesMasks,
  fetchMessagesMasks,
  fetchSituationsByClientType,
  fetchedSituationsByClientType,
} from './actions';
import { State } from './types';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  data: [],
  selectedMessageMask: undefined,
  situationsByClientType: {
    status: undefined,
    error: undefined,
    data: [],
  },
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(fetchMessagesMasks, (state) => {
      state.status = 'loading';
    })
    .addCase(fetchedMessagesMasks, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.data = payload as State['data'];
        state.error = undefined;
        state.status = 'success';
      }
    })

    .addCase(fetchMessageMask, (state) => {
      state.status = 'loading';
    })
    .addCase(fetchedMessageMask, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.selectedMessageMask = payload as State['selectedMessageMask'];
        state.error = undefined;
        state.status = 'success';
      }
    })

    .addCase(updateMessageMask, (state) => {
      state.status = 'loading';
    })
    .addCase(updatedMessageMask, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.error = undefined;
        state.status = 'success';
      }
    })

    .addCase(fetchSituationsByClientType, (state) => {
      state.situationsByClientType.status = 'loading';
    })
    .addCase(fetchedSituationsByClientType, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.situationsByClientType.error = payload as RequestError;
        state.situationsByClientType.status = 'error';
      } else {
        state.situationsByClientType.data = payload as State['situationsByClientType']['data'];
        state.situationsByClientType.error = undefined;
        state.situationsByClientType.status = 'success';
      }
    })
);
